import React from 'react';
import Header from '../Utils/Header'
import Footer from '../Utils/Footer'
import doctores from '../images/doctors.png'
import { Link } from "react-router-dom";

const Inicio = () => {
    return ( 
        <>
        <Header/>
        <section id="header" className="bg-header mt-3 prestadores-header ">
            <div className="container-fluid py-5 top-bienvenido">
                <div className="container py-4">
                    <div className="row">
                        <div className="col-12 bg-bienvenido ">
                            <h2 className="font-celeste-top ">BIENVENIDOS</h2>
                            <p className="col-12 col-lg-5 mx-0 px-0 text-justify">El portal SuperSalud Desarrolladores, es una iniciativa de la Superintendencia de Salud, con el objetivo de agilizar el desarrollo de productos y/o servicios digitales que requieran el uso intensivo de datos, de manera simple y estandarizada, mediante métodos agrupados por temas que se encuentran disponibles en el catálogo de APIs.</p>
                        </div>
                        
                        <div className="col-12 col-lg-5 bg-lightt border-head">
                            <h5 className="font-weight-bold font-celeste my-4">¿QUÉ ES UNA API?</h5>
                            <p className="text-justify">El portal SuperSalud Desarrolladores, es una iniciativa de la Superintendencia de Salud, con el objetivo de agilizar el desarrollo de productos y/o servicios digitales que requieran el uso intensivo de datos, de manera simple y estandarizada, mediante métodos agrupados por temas que se encuentran disponibles en el catálogo de APIs.</p>
                        </div>

                        <div className="col-12 col-lg-5 bg-para border-head ">
                            <h5 className="font-weight-bold font-celeste my-4">¿PARA QUÉ SIRVE?</h5>
                            <p className="text-justify">En general las APIs son usadas en las bibliotecas de programación, para integrar sistemas y aplicaciones.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="comencemos" className="bg-light img-comencemos">
            <div className="container pb-5">
                <div className="row">
                    <div className="col-12 mt-3 mb-5">
                        <h2 className="font-celeste-top">COMENCEMOS</h2>
                    </div>

                    <div className="col-12 col-lg-4 bg-step ">
                        <div className="d-inline">
                        <p className="num-prestador d-inline mr-3">1</p>
                        </div>
                        <div className="d-inline">
                        <span className="text-justify text-num">OBTENER UNA CLAVE</span>
                        <p className=" mr-3  text-num">Para obtener una AUTH KEY debes registrarte.</p>
                        <hr/>
                        </div>

                        {/* Para obtener una AUTH KEY debes registrarte. */}
                        
                        <p className="text-justify text-mid">Obtener una AUTHKEY y acceder a cualquier método a través de ella.</p>
                    </div>

                    <div className="col-12 col-lg-4 bg-step">
                        <p className="num-prestador d-inline mr-3">2</p>
                        <span className="text-justify ">CREAR UNA SOLICITUD </span>
                        <p className="mr-3 text-num">La API acepta solicitudes RESTfuls</p>
                        <hr/>
                        
                        <p className=" text-mid">
                            Una solicitud típica luce así: 
                            <code className="text-dark">
                            {" "+process.env.REACT_APP_ENLACE_EXT}prestadores/rut/13029926.json/?apikey=YOUR_AUTH_KEY
                            </code>
                            
                        </p>

                        <p className="text-justify text-mid">
                            Algunas puntos importantes en la solicitud anterior:
                            /prestadores es el nombre de la API.
                            /prestadores/rut es el método.
                            auth_key=TU_AUTH_KEY 
                            Esta es la clave que necesitarás para cada solicitud.
                        </p>
                    </div>
                    
                    <div className="col-12 col-lg-4 bg-step ">
                        <p className="num-prestador d-inline mr-3">3</p>
                        <span>PROCESAR LA RESPUESTA</span>
                        <p className="text-justify text-num">La respuesta será en formato JSON.</p>
                        <hr/>
                        

                        <p className="text-justify text-mid">Para más información lee la documentación de la API.</p>
                    </div>

                </div>
            </div>
        </section>

        <section id="comencemos" className="bg-light ">
            <div className="container py-5">
                <h2 className="font-celeste-top">CATÁLOGO DE APIS</h2>
                <div className="row bg-catalogo">
                        <div className="col-12 col-lg-4 p-5 text-justify text-center">
                            <img alt="doctor" src={doctores} className="img-fluid doctors" />
                            <Link to='/prestadores'>
                                <p className="font-weight-bold">PRESTADORES</p>
                            </Link>
                            <span>Datos del Registro Nacional de Prestadores Individuales de Salud</span>
                        </div>
                </div>
            </div>
        </section>

        <Footer/>

        </>
     );
}
 
export default Inicio;